import { useWizard } from "react-use-wizard";
import dealServiceSteps from "./dealServiceSteps";
import { IFillDataWizardDealService, TKeyOfDataWizardDealService } from "..";
import EstimateStep from "../../../../../shared/wizard/steps/estimateStep";
import { IDataFormEstimate } from "../../../../estimate";

interface IStepDealService_5 {
  onChange: (data: Partial<IFillDataWizardDealService>) => void;
  dataFormEstimate: Partial<IFillDataWizardDealService>;
  onReset: (keys: TKeyOfDataWizardDealService[], data?: number[]) => void;
  isNextStepDisabled: boolean;
}

const StepDealService_5 = ({
  dataFormEstimate,
  isNextStepDisabled,
  onChange,
  onReset,
}: IStepDealService_5) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(dealServiceSteps.step_4);
    onReset(["streetId", "buildingId", "areaInSqM", "facilityTypeId"]);
  };

  const handleNextStep = () => {
    goToStep(dealServiceSteps.step_6);
  };

  const dataFormEstimateChecked = Boolean(
    dataFormEstimate.areaInSqM &&
      dataFormEstimate.buildingId &&
      dataFormEstimate.streetId
  );

  return (
    <div>
      <EstimateStep
        mode="dealService"
        onEstimatePrice={() => {}}
        onEstimateForm={onChange}
        onNexStep={handleNextStep}
        onPrevStep={handlePrevStep}
        isNextStepDisabled={isNextStepDisabled}
        dataFormEstimate={
          dataFormEstimateChecked
            ? (dataFormEstimate as IDataFormEstimate)
            : undefined
        }
      />
    </div>
  );
};

export default StepDealService_5;
